/**
 * @Author:
 * @Description:
 * @DateTime: Created in 16:42 2018/11/13
 */
import * as Vue from 'vue-tsx-support';
import { Component } from 'vue-property-decorator';
import 'vue-tsx-support/enable-check';
import './indexPage.less';
import { createBEM } from 'src/util/bem';
import StationInfo from './component/stationInfo';
import OverproofDistribution from './component/overproofDistribution';
import MalfunctionStation from './component/malfunctionStation';
import OverproofStation from './component/overproofStation';
import QualityRank from './component/qualityRank';
import EnumStationType from 'src/enums/enumStationType';
import Icon from 'src/types/iview/Icon';
import CenterMap from './component/centerMap';
import RouteUtils from 'src/util/routeUtils';
import { DateTimeUtil } from 'src/util/dateTimeUtil';
import { LoginDOI } from '../login/loginApi';
import LocalStore from 'src/util/LocalStore';
let bem = createBEM('index-page');
const loopTime = 5000;
@Component({
    name: 'index-page',
})
export default class IndexPage extends Vue.Component<any> {
    type: number = EnumStationType.Water.getId();

    map: any;
    time: string = '';
    itv: any;
    // 系统名称
    system_name: string = "";
    //英文系统名称
    english_system_name: string = "";

    mounted() {
        this.time = DateTimeUtil.formateDate(new Date());
        this.itv = setInterval(() => {
            this.time = DateTimeUtil.formateDate(new Date(), 'YYYY年MM月DD日 HH:mm:ss');
        }, 1000);
        let userInfo: LoginDOI.LoginResultI = LocalStore.getData('userInfo');
        if (userInfo.system_name !== undefined) {
            this.system_name = userInfo.system_name;
        }
        if(userInfo.english_system_name !== undefined){
            this.english_system_name = userInfo.english_system_name;
        }
    }

    beforeDestroy() {
        clearInterval(this.itv);
    }

    render(h) {
        return (
            // <dv-border-box-11 title="dv-border-box-11" style="width:400px;height:300px">dv-border-box-11</dv-border-box-11>
            <div class={bem()}>
                <div class={bem('center')}>
                    {/* 地图 */}
                    <CenterMap type={this.type} />
                    {/* 底图边框 */}
                    <div class={bem('centerbg')} />
                    {/* 标题 */}
                    <div class={bem('head')}>
                        <div class={bem('head-left')}></div>
                        <div class={bem('head-center')}>
                            <p v-if={this.system_name.length> 11} on-click={() => RouteUtils.goTo('/gis/index')} class={bem('head-text-11')}>{this.system_name}</p>
                            <p v-else on-click={() => RouteUtils.goTo('/gis/index')} class={bem('head-text')}>{this.system_name}</p>
                            <p v-if={this.system_name.length> 11} on-click={() => RouteUtils.goTo('/gis/index')} class={bem('head-text-en-11')}>{this.english_system_name}</p>
                            <p v-else on-click={() => RouteUtils.goTo('/gis/index')} class={bem('head-text-en')}>{this.english_system_name}</p>
                        </div>
                        <div class={bem('head-right')}></div>
                    </div>
                    {/* 左右布局 */}
                    <div class={bem('center-left')}>
                        <StationInfo type={this.type} />
                        <MalfunctionStation type={this.type} />
                        <QualityRank rankType="top" time={loopTime} type={this.type} />
                    </div>
                    <div
                        class={bem('type-change')}
                        on-click={() =>
                            this.type === EnumStationType.Water.getId()
                                ? (this.type = EnumStationType.Pollution.getId())
                                : (this.type = EnumStationType.Water.getId())
                        }
                    >
                        {this.type === EnumStationType.Water.getId() ? '地表水监测' : '污染源监测'}
                        <Icon type="ios-arrow-forward" />
                    </div>
                    <div class={bem('center-right')}>
                        <OverproofDistribution type={this.type} />
                        <OverproofStation time={loopTime} type={this.type} />
                        <QualityRank rankType="last" time={loopTime} type={this.type} />
                    </div>
                    <div class={bem('time')}>{this.time}</div>
                </div>
            </div>
        );
    }
}
